import React, { useState } from "react";
import {
  Box,
  Button,
  Card,
  CardBody,
  Checkbox,
  Flex,
  Grid,
  GridItem,
  Input,
  Select,
  Text,
  VisuallyHidden,
  Tooltip,
  Textarea,
  Spinner,
  useToast,
} from "@chakra-ui/react";
import { DocIcon, DocLargeIcon, DownloadIcon } from "../../assets/svgs/Icons";
import { FiUpload } from "react-icons/fi";
import { FileIcon, RemoveIcon } from "../../assets/svgs/Icons";
import { toast } from "react-toastify";
import { checkFileTypesAndSize } from "../../Common/utils";

function TcFormCards3({
  invoiceFile,
  setInvoiceFile,
  transportFile,
  setTransportFile,
  documentFile,
  setDocumentFile,
  totalGrossWeight,
  totalNetWeight,
  totalCertifiedWeight,
  setDeclare,
  invoiceDocTitle,
  setInvoiceDocTitle,
  transportDocTitle,
  setTransportDocTitle,
  documentTitle,
  setDocumentTitle,
}) {
  const [isUploading, setIsUploading] = useState(false);
  const [isUploadingInvoice, setIsUploadingInvoice] = useState(false);
  const [isUploadingTransport, setIsUploadingTransport] = useState(false);
  const [isUploadingDocument, setIsUploadingDocument] = useState(false);
  const toast1 = useToast();

  const handleInvoiceFileChange = (event) => {
    const file = event.target.files[0];
    const validation = checkFileTypesAndSize(
      file.name,
      file.type,
      file.size,
      10485760
    );

    if (!validation.isValid) {
      toast.error(validation.error);
      return;
    }

    toast1({
      position: "top",
      description: "Your Invoice document is being uploaded.",
      status: "info",
      duration: 2000,
      isClosable: true,
    });

    setTimeout(() => {
      setInvoiceFile(file);
    }, 2000);

    handleFileUpload(file, setIsUploadingInvoice);
  };

  const handleTransportFileChange = (event) => {
    const file = event.target.files[0];
    const validation = checkFileTypesAndSize(
      file.name,
      file.type,
      file.size,
      10485760
    );

    if (!validation.isValid) {
      toast.error(validation.error);
      return;
    }

    toast1({
      position: "top",
      description: "Your Transport document is being uploaded.",
      status: "info",
      duration: 2000,
      isClosable: true,
    });

    setTimeout(() => {
      setTransportFile(file);
    }, 2000);

    handleFileUpload(file, setIsUploadingTransport);
  };

  const handleDocumentFileChange = (event) => {
    const file = event.target.files[0];
    const validation = checkFileTypesAndSize(
      file.name,
      file.type,
      file.size,
      10485760
    );

    if (!validation.isValid) {
      toast.error(validation.error);
      return;
    }

    toast1({
      position: "top",
      description: "Your Other document is being uploaded.",
      status: "info",
      duration: 2000,
      isClosable: true,
    });

    setTimeout(() => {
      setDocumentFile(file);
    }, 2000);

    handleFileUpload(file, setIsUploadingDocument);
  };

  const handleFileUpload = (file, setIsUploading) => {
    setIsUploading(true);
    setTimeout(() => {
      setIsUploading(false);
      toast.success("Your document is uploaded successfully.");
    }, 2000);
  };

  return (
    <>
      <Box bg="#FFFFFF" padding={"2rem"} marginTop="2rem" borderRadius={"15px"}>
        <Tooltip label="Kindly ensure that each document uploaded is unique and distinct.">
          <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
            Add Supporting Documents
          </Text>
        </Tooltip>
        <Flex
          direction={{ base: "row", md: "row", xl: "column" }}
          marginTop="2rem"
          borderRadius={"15px"}
        >
          <Grid
            width={"100%"}
            mt={{ base: "0rem", md: "0rem", xl: "3rem" }}
            mb={"2rem"}
            gap={{ base: "1rem", md: "1rem", xl: "3rem" }}
            height={"100%"}
            templateColumns={{
              base: "1fr",
              md: "1fr",
              xl: "repeat(3, 1fr)",
            }}
          >
            <GridItem>
              <Button
                bg="#FFFFFF"
                color={"black"}
                width={"270"}
                height={"175"}
                leftIcon={<FiUpload />}
                borderRadius={"15px"}
                as="label"
                htmlFor="file-upload-invoice"
                variant="outline"
              >
                Upload Invoice Document
                <Text as="span" color="red">
                                *
                              </Text>
                <VisuallyHidden>
                  <input
                    id="file-upload-invoice"
                    type="file"
                    onChange={handleInvoiceFileChange}
                  />
                </VisuallyHidden>
              </Button>
              {isUploadingInvoice && <Spinner />}
            </GridItem>

            <GridItem>
              <Button
                bg="#FFFFFF"
                color={"#000000"}
                width={"270"}
                height={"175"}
                leftIcon={<FiUpload />}
                borderRadius={"15px"}
                as="label"
                htmlFor="file-upload-transport"
                variant="outline"
              >
                Upload Transport Document
                <Text as="span" color="red">
                                *
                              </Text>
                <VisuallyHidden>
                  <input
                    id="file-upload-transport"
                    type="file"
                    onChange={handleTransportFileChange}
                  />
                </VisuallyHidden>
              </Button>
              {isUploadingTransport && <Spinner />}
            </GridItem>

            <GridItem>
              <Button
                bg="#FFFFFF"
                color={"black"}
                width={"270"}
                height={"175"}
                leftIcon={<FiUpload />}
                borderRadius={"15px"}
                as="label"
                htmlFor="file-upload-document"
                variant="outline"
              >
                Upload other Document
                <Text as="span" color="red">
                                *
                              </Text>
                <VisuallyHidden>
                  <input
                    id="file-upload-document"
                    type="file"
                    onChange={handleDocumentFileChange}
                  />
                </VisuallyHidden>
              </Button>
              {isUploadingDocument && <Spinner />}
            </GridItem>
          </Grid>
          <Grid
            templateColumns={{
              base: "1fr",
              md: "1fr",
              xl: "repeat(3, 1fr)",
            }}
            gap={{ base: "1rem", md: "1rem", xl: "3rem" }}
            mb={{ base: "0rem", md: "0rem", xl: "2rem" }}
          >
            <GridItem>
              {invoiceFile && (
                <GridItem colSpan={1}>
                  <Box display={"flex"} className="overflow-style">
                    <>
                      <Box
                        bg="#FFFFFF"
                        w={"270px"}
                        h={"175px"}
                        borderRadius={"15px"}
                        boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
                      >
                        <Box display={"flex"} justifyContent={"right"}>
                          <Button
                            borderColor="#FFFFFF"
                            bg="#ffffff"
                            size="sm"
                            variant="outline"
                            onClick={() => setInvoiceFile()}
                            leftIcon={<RemoveIcon />}
                          ></Button>
                        </Box>
                        <Box display={"flex"} justifyContent={"center"}>
                          <FileIcon />
                        </Box>
                        <Tooltip label={invoiceFile?.name}>
                          <Text
                            margin={"auto"}
                            width={"130px"}
                            whiteSpace={"nowrap"}
                            overflow={"hidden"}
                            textOverflow={"ellipsis"}
                          >
                            {invoiceFile?.name}
                          </Text>
                        </Tooltip>
                      </Box>
                    </>
                  </Box>
                </GridItem>
              )}
            </GridItem>
            <GridItem>
              {transportFile && (
                <GridItem colSpan={1}>
                  <Box display={"flex"} className="overflow-style">
                    <>
                      <Box
                        bg="#FFFFFF"
                        w={"270px"}
                        h={"175px"}
                        borderRadius={"15px"}
                        boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
                      >
                        <Box display={"flex"} justifyContent={"right"}>
                          <Button
                            borderColor="#FFFFFF"
                            bg="#ffffff"
                            size="sm"
                            variant="outline"
                            onClick={() => setTransportFile()}
                            leftIcon={<RemoveIcon />}
                          ></Button>
                        </Box>
                        <Box display={"flex"} justifyContent={"center"}>
                          <FileIcon />
                        </Box>
                        <Tooltip label={transportFile?.name}>
                          <Text
                            width={"130px"}
                            margin={"auto"}
                            whiteSpace={"nowrap"}
                            overflow={"hidden"}
                            textOverflow={"ellipsis"}
                          >
                            {transportFile?.name}
                          </Text>
                          
                        </Tooltip>
                      </Box>
                    </>
                  </Box>
                </GridItem>
              )}
            </GridItem>
            <GridItem>
              {documentFile && (
                <GridItem colSpan={1}>
                  <Box display={"flex"} className="overflow-style">
                    <>
                      <Box
                        bg="#FFFFFF"
                        w={"270px"}
                        h={"175px"}
                        borderRadius={"15px"}
                        textAlign={"center"}
                        boxShadow={"rgba(100, 100, 111, 0.2) 0px 10px 26px 0px"}
                      >
                        <Box display={"flex"} justifyContent={"right"}>
                          <Button
                            borderColor="#FFFFFF"
                            bg="#ffffff"
                            size="sm"
                            variant="outline"
                            onClick={() => setDocumentFile()}
                            leftIcon={<RemoveIcon />}
                          ></Button>
                        </Box>
                        <Box display={"flex"} justifyContent={"center"}>
                          <FileIcon />
                        </Box>
                        <Tooltip label={documentFile?.name}>
                          <Text
                            width={"130px"}
                            margin={"auto"}
                            whiteSpace={"nowrap"}
                            overflow={"hidden"}
                            textOverflow={"ellipsis"}
                          >
                            {documentFile?.name}
                          </Text>
                        </Tooltip>
                      </Box>
                    </>
                  </Box>
                </GridItem>
              )}
            </GridItem>
          </Grid>
        </Flex>
        <Grid templateColumns="repeat(3, 1fr)" gap="3rem" mt="1rem">
          <GridItem>
            <Input
              type="tel"
              color={"#141D43"}
              border="2px solid  #8fd0fd !important"
              marginTop="10px"
              bg={"#fff"}
              fontSize={"14px"}
              opacity={"1 !important"}
              w="80%"
              _placeholder={{
                opacity: 0.5,
                color: "#141D43",
                fontSize: "14px",
              }}
              placeholder="Enter title for Invoice document"
              value={invoiceDocTitle}
              onChange={(e) => setInvoiceDocTitle(e.target.value)}
            />
          </GridItem>
          <GridItem>
            <Input
              type="tel"
              color={"#141D43"}
              border="2px solid  #8fd0fd !important"
              marginTop="10px"
              bg={"#fff"}
              fontSize={"14px"}
              opacity={"1 !important"}
              w="80%"
              _placeholder={{
                opacity: 0.5,
                color: "#141D43",
                fontSize: "14px",
              }}
              placeholder="Enter title for Transport document"
              value={transportDocTitle}
              onChange={(e) => setTransportDocTitle(e.target.value)}
            />
          </GridItem>
          <GridItem>
            <Input
              type="tel"
              color={"#141D43"}
              border="2px solid  #8fd0fd !important"
              marginTop="10px"
              bg={"#fff"}
              fontSize={"14px"}
              opacity={"1 !important"}
              w="80%"
              _placeholder={{
                opacity: 0.5,
                color: "#141D43",
                fontSize: "14px",
              }}
              placeholder="Enter title for Other document"
              value={documentTitle}
              onChange={(e) => setDocumentTitle(e.target.value)}
            />
          </GridItem>
        </Grid>
      </Box>
      <Box bg="#FFFFFF" padding={"2rem"} marginTop="2rem" borderRadius={"15px"}>
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
          Total Weight Details
        </Text>
        <Box
          border={"2px solid #2272D5"}
          width="15%"
          marginBottom={"1rem"}
          mt="1rem"
        ></Box>
        <Box paddingLeft={"3rem"}>
          <Box>
            <Grid
              alignItems={"flex-end"}
              gap={"3rem"}
              templateColumns="repeat(1, 1fr)"
              marginTop={"1rem"}
            >
              <Box
                display={"flex"}
                flexDirection="column"
                alignItems="flex-start"
                justifyContent={"center"}
              >
                <Grid
                  width={"100%"}
                  templateColumns="repeat(4, 1fr)"
                  my={"1rem"}
                  gap="3rem"
                >
                  <GridItem colSpan={1}>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Gross Weight(kg)
                    </Text>
                    <Input
                      type="tel"
                      color={"#141D43"}
                      border="2px solid  #8fd0fd !important"
                      marginTop="10px"
                      bg={"#fff"}
                      fontSize={"14px"}
                      disabled
                      opacity={"1 !important"}
                      value={totalGrossWeight ? totalGrossWeight : 0}
                      w="80%"
                      _placeholder={{
                        opacity: 1,
                        color: "#141D43",
                        fontSize: "14px",
                      }}
                    />
                  </GridItem>
                  <GridItem colSpan={1}>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Net Weight(kg)
                    </Text>
                    <Input
                      type="tel"
                      color={"#141D43"}
                      border="2px solid  #8fd0fd !important"
                      marginTop="10px"
                      bg={"#fff"}
                      fontSize={"14px"}
                      disabled
                      opacity={"1 !important"}
                      value={totalNetWeight ? totalNetWeight : 0}
                      w="80%"
                      _placeholder={{
                        opacity: 1,
                        color: "#141D43",
                        fontSize: "14px",
                      }}
                    />
                  </GridItem>
                  <GridItem colSpan={1}>
                    <Text
                      color={"#141D43"}
                      fontSize="md"
                      fontWeight={"700"}
                      fontFamily={"font.roboto"}
                    >
                      Certified Weight(kg)
                    </Text>

                    <Input
                      type="tel"
                      color={"#141D43"}
                      border="2px solid  #8fd0fd !important"
                      marginTop="10px"
                      bg={"#fff"}
                      fontSize={"14px"}
                      disabled
                      opacity={"1 !important"}
                      value={totalCertifiedWeight ? totalCertifiedWeight : 0}
                      w="80%"
                      _placeholder={{
                        opacity: 1,
                        color: "#141D43",
                        fontSize: "14px",
                      }}
                    />
                  </GridItem>
                </Grid>
              </Box>
            </Grid>
          </Box>
        </Box>
      </Box>
      <Box bg="#FFFFFF" padding={"2rem"} marginTop="2rem" borderRadius={"15px"}>
        <Text color={"#141D43"} fontSize="lg" fontWeight={"800"}>
          Declaration of the body issuing the certificate:
        </Text>
        <Box paddingLeft={"3rem"}>
          <Box>
            <Grid
              gap={"3rem"}
              templateColumns="repeat(1, 1fr)"
              marginTop={"1rem"}
            >
              <GridItem colSpan={1}>
                <Checkbox
                  colorScheme={"checkbox"}
                  fontWeight="700"
                  onChange={(e) => setDeclare(e.target.checked)}
                  defaultChecked
                >
                  I, the exporter, declare that the consignment concerned has
                  been produced and/or prepared in accordance with the
                  provisions of the General Certificate of Conformity Standards
                  as well as the Control Union Certifications Inspection
                  Regulations. This form has been completed truthfully and to
                  the best of my knowledge.
                </Checkbox>
              </GridItem>
              {/* <GridItem>
                <Text
                  color={"#141D43"}
                  fontSize="md"
                  fontWeight={"700"}
                  fontFamily={"font.roboto"}
                >
                  Additional Decleration
                </Text>
                <Input
                  type="tel"
                  color={"#141D43"}
                  border="2px solid  #8fd0fd !important"
                  marginTop="10px"
                  bg={"#fff"}
                  fontSize={"14px"}
                  w="100%"
                  placeholder="Certification of the organic material used for the products listed complies with:"
                  _placeholder={{
                    opacity: 1,
                    color: "#141D43",
                    fontSize: "14px",
                  }}
                />
              </GridItem> */}
            </Grid>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default TcFormCards3;
